"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reactRhumb = require("react-rhumb");

var _I18n = _interopRequireDefault(require("I18n"));

var _UISubheader = _interopRequireDefault(require("UIComponents/layout/UISubheader"));

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _selectors = require("settings-ui-sdk/SiteSettings/selectors");

var _StickySaveFooterContainer = _interopRequireDefault(require("./shared/StickySaveFooterContainer"));

var _loadOnMount = _interopRequireDefault(require("settings-ui-sdk/app/containers/hoc/loadOnMount"));

var _stageOnMount = _interopRequireDefault(require("settings-ui-sdk/app/containers/hoc/stageOnMount"));

var _TabsContainer = _interopRequireDefault(require("./shared/TabsContainer"));

var _AccessControl = require("../constants/AccessControl");

var _UpdateEmailSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateEmailSiteSettings"));

var _selectors2 = require("settings-ui-sdk/Auth/selectors");

var _UnauthorizedPage = _interopRequireDefault(require("settings-ui-sdk/Auth/UnauthorizedPage"));

var _actions2 = require("settings-ui-sdk/CanSpamSettings/actions");

var _selectors3 = require("settings-ui-sdk/CanSpamSettings/selectors");

var EmailSettingsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(EmailSettingsContainer, _PureComponent);

  function EmailSettingsContainer() {
    (0, _classCallCheck2.default)(this, EmailSettingsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmailSettingsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(EmailSettingsContainer, [{
    key: "render",
    value: function render() {
      if (!this.props.hasEmailSettingsAccess) {
        return _react.default.createElement(_reactRhumb.NavMarker, {
          name: "EMAIL_SETTINGS_NO_ACCESS_LOADED"
        }, _react.default.createElement(_UnauthorizedPage.default, {
          moduleName: "marketing.email"
        }));
      }

      return _react.default.createElement("div", {
        className: "m-bottom-10"
      }, _react.default.createElement(_StickySaveFooterContainer.default, null), _react.default.createElement(_UISubheader.default, {
        tabs: _react.default.createElement(_TabsContainer.default, null),
        title: _I18n.default.text('marketing.email.pageTitle')
      }), this.props.children);
    }
  }]);
  return EmailSettingsContainer;
}(_react.PureComponent);

EmailSettingsContainer.propTypes = {
  children: _react.PropTypes.node,
  hasEmailSettingsAccess: _react.PropTypes.bool
};

var _default = (0, _redux.compose)((0, _loadOnMount.default)([_actions.loadSiteSettings, _actions2.loadCanSpamSettings], [_selectors.getFetchSiteSettingsRequestStatus, _selectors3.getFetchCanSpamSettingsRequestStatus], _AccessControl.EMAIL_SETTINGS_READ, true, _react.default.createElement(_reactRhumb.NavMarker, {
  name: "EMAIL_SETTINGS_LOADED"
}), _react.default.createElement(_reactRhumb.NavMarker, {
  name: "EMAIL_SETTINGS_LOADED_FAILURE"
})), (0, _stageOnMount.default)(_UpdateEmailSiteSettings.default.getDomainObject, _UpdateEmailSiteSettings.default.stageForEdit), (0, _reactRedux.connect)(function (state) {
  return {
    hasEmailSettingsAccess: (0, _selectors2.hasEmailSettingsAccess)(state)
  };
}))(EmailSettingsContainer);

exports.default = _default;
module.exports = exports.default;